module.exports = __webpack_public_path__ + "img/mian.a6af141f.png";